import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueFeather = _resolveComponent("VueFeather")!

  return (_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addToCartOnClick && _ctx.addToCartOnClick(...args)), ["prevent"])),
    class: "bg-gray-700 inline-block px-3 py-3 hover:bg-red-500 transition duration-300 ease-in-out"
  }, [
    _createVNode(_component_VueFeather, {
      type: "shopping-cart",
      class: "transition duration-300 ease-in-out flex justify-center items-center text-gray-100"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" Test ", -1)
      ]))]),
      _: 1
    })
  ]))
}